import { createApp } from 'vue'

import App from './App.vue'

import router from './router'
import UIkit from 'uikit'

import '@/assets/styles/styles.scss'
import Icons from 'uikit/dist/js/uikit-icons'
import store from './store'
import axios from 'axios'



UIkit.use(Icons)



axios.defaults.headers['X-Header-token-api'] = "bQAVWhAHRwGJQtGcP4hQtKQ68GZTHXVJpfCBjSuuFTNzZvnW"
store.dispatch('LOAD_All')

createApp(App).use(store).use(router).mount('#app')